<template>
    <div :class="['el-card  pd20 label-management',storage?'on':'']">
        <!-- 返回 -->
        <div class="top-head">
            <div class="cancel-box">
                <el-button type="info" icon="el-icon-arrow-left"  @click="$router.go(-1)"  size="medium">返回标签列表</el-button>
            </div>
            <el-divider></el-divider>
        </div>
        <!--  -->
        <el-form class="form" ref="form"  label-width="80px">
            <el-form-item label="标签名称">
                <el-input v-model="labelName" placeholder="请输入标签名称"></el-input>
            </el-form-item>
            <el-form-item label="搜索用户">
                <el-input v-model="searchName" placeholder="请输入用户名称">
                    <el-button @click="pullData" slot="append" icon="el-icon-search"></el-button>
                </el-input>
            </el-form-item>
        </el-form>
        <!-- 穿梭框 -->
        <div class="label-tranfer">
            <el-transfer
                @change="transferHandel"
                :titles="['所有用户', '标记用户']"
                v-model="user_list"
                ref="myTransfer"
                :data="list">
                <span slot-scope="{ option }" :title="option.label"><img class="headimg" :src="option.headLink" /> - {{ option.label }}</span>
                <!-- 分页 -->
                <el-pagination class="transfer-footer pages"
                    :small="true"
                    slot="left-footer" 
                    :page-sizes="[25, 50, 75, 100]"
                    @size-change="handleSizeChange"
                    @current-change="handleCurrentChange"
                    :page-size="pages.size"
                    :current-page="pages.page"
                    :pager-count="3"
                    background
                    layout="sizes,prev, pager, next"
                    :total="pages.count">
                </el-pagination>
            </el-transfer>
        </div>
       
        <div  class="submit-group">
            <el-button type="primary" @click="submit" >保存标签</el-button>
        </div>
    </div>
</template>

<script>
import { getStorage } from '@u/tools'
import { getUser,labelAdd,labelEdit,listDel } from "@/api/operating";
export default {
    data() {
        return{
            pages: {},
            labelName:'',
            user_list:[],
            list:[],
            // 
            label_list:[],
            searchName:'',
            // 
            label_bool:true,
            new_list:[]
        }
    },
    computed:{
        storage(){
            return getStorage('/public_bg_type')==1
        }
    },
    methods:{
        // 调整每页显示条数
        handleSizeChange(val) {
            this.pages.size = val;
            this.pullData();
        },
        // 触发分页
        handleCurrentChange(val) {
            this.pages.page = val;
            this.pullData();
        },
        // 监听左右用户改变
        transferHandel(rightArr,position,leftArr){
            if(position==='left'){
                for(let key in leftArr){
                    for(let index in this.label_list){
                        if(this.label_list[index].key==leftArr[key]){
                            listDel({
                                id:this.label_list[index].list_id
                            }).then((data)=>{

                                this.label_list.splice(index, 1);
                                this.$message('移除用户成功！');
                            });
                        }
                    }
                }
                
            }
        },
        submit(){
            let arr = [];
            for(let key in this.user_list){
                arr.push({
                    id:this.user_list[key]
                })
            }

            let obj = {
                name:this.labelName,
                list:arr
            };
            // 判断是否存在标签id
            if(this.$route.query.id){
                obj['id'] = this.$route.query.id;
            }
            labelAdd(obj).then((data)=>{
                if(data.error >0){
                    this.$message(data.msg);
                    return
                }
                this.$notify({
                    title: '成功',
                    message: '提交成功！',
                    type: 'success'
                });
                this.$router.go(-1);
            });
        },
        pullData(){
            this.$showLoading();
            this.obj = {
                page:Object.keys(this.pages).length>0?this.pages.page:1,  //页码，默认1
                size:Object.keys(this.pages).length>0?this.pages.size:25   //每页数量，默认25
            };
            if(this.searchName){
                this.obj['nickname'] = this.searchName;
            }
            let getUserList = getUser(this.obj);

            let arr = [getUserList];

            if(this.$route.query.id && this.label_bool){
                arr.push(labelEdit({id:this.$route.query.id}));
            }

            Promise.all(arr).then((data)=>{
                this.list.splice(0,this.list.length);
                for(let i=0;i< data[0].list.length;i++){

                    this.list.push({
                        label:data[0].list[i].nickname,
                        key:data[0].list[i].id,
                        headLink:data[0].list[i].headimgurl
                    });
                }
                this.pages = data[0].pager;
                if(this.$route.query.id && this.label_bool){
                   
                    for(let key in data[1].list.list){
                        this.$set(this.user_list,key,data[1].list.list[key].id); 
                    
                        this.label_list[key] = {
                            label:data[1].list.list[key].nickname,
                            key:data[1].list.list[key].id,
                            headLink:data[1].list.list[key].headimgurl,
                            list_id:data[1].list.list[key].list_id
                        };
 
                    }
                    this.labelName = data[1].list.name;
                }


                for(let i = 0; i < this.list.length; i++) {
                    if(this.user_list.indexOf(this.list[i].key) < 0) {
                        this.new_list.push(this.list[i])
                    }
                }

                
                this.list = [...this.new_list,...this.label_list];
                this.label_bool = false;
                this.$hideLoading();
                
            }).catch((err)=>{
                this.$hideLoading();
            });
        }
    },
    created(){
        this.pullData();
    }    
}
</script>

<style lang="scss" scoped>
.label-management{
    padding:30px 0 100px 0;
    .headimg{
        width:20px;
        height: 20px;
        border-radius: 50%;
        vertical-align: middle;
    }
    .form{
        margin-left: 20px;
    }
    .label-tranfer{
        margin: auto 100px;
        display: flex;
        align-items: center;
    }
    .top-head{
        margin-bottom: 20px;
        padding:0 20px;
    }
    .submit-group{
        margin-left: 100px;
        margin-top: 30px;
    }
}
.pages{
  text-align: right;

}


</style>
<style lang="scss">
.label-management{
    .el-transfer-panel__body{
        height: 350px;
    }
    .el-transfer-panel{
        width: 300px;
    }
    .el-transfer-panel__list.is-filterable{
        height: 300px;
    }
    .form .el-input{
        width: 800px;
    }
    .el-checkbox.el-transfer-panel__item{
        display: block;
    }
    .el-transfer-panel__list{
        height: 310px;
    }
    .el-transfer-panel__footer{
        padding-top: 3px;
    }
    .el-pagination.is-background .btn-next, .el-pagination.is-background .btn-prev, .el-pagination.is-background .el-pager li{
        min-width: 15px;
    }
}
.label-management.on{
    .el-transfer-panel__footer{
        display: block;
        padding-top: 20px;
        background-color: rgba(0,0,0, .4)
    }
}

</style>
